import { gql } from '@apollo/client';
import CommonFragments from 'features/common/fragments';

export const NON_WORKING_DAY_SAVED = gql`
  subscription nonWorkingDaySaved {
    nonWorkingDaySaved {
      nonWorkingDay {
        nonWorkingDayDate
        description
        nonWorkingDayId
        workingSiteId
        workingDay
        validInAllContexts
        contexts
      }
      headers {
        ...messageHeaders
      }
    }
  }
  ${CommonFragments.messageHeaders}
`;
